
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 10c0-1.657 1.52-3 3.396-3h21.508C34.78 7 36.3 8.343 36.3 10v24c0 1.657-1.52 3-3.396 3H11.396C9.52 37 8 35.657 8 34V10z","stroke":"#363636","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M15 20.4h5M23 20.4h6M15 14h7M29 14h-4","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M17.134 27c-.888 1.177-1.75 2.48-2.08 3.94-.155.681-.02 1.864 1 1.445.307-.127 1.814-1.744 1.954-1.605.238.238.106.58.611.469.475-.105.867-.491 1.215-.802.434-.387.957-.099 1.525-.048 1.002.09 2.078.712 3.05.429 1.76-.514 3.354-.254 5.162-.254","stroke":"#DD8500","stroke-width":"2","stroke-linecap":"round"}})])
          )
        }
      }
    